import { Controller } from "stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["nomDevice", "typeSelect", "severitySelect", "severityHidden", "submitButtons", "lockedMessage"]
  static values = { locked: Boolean }

  initialize() {
    this.isSecurityForm = false
    this.toggle(false)
    const controller = this
    window.addEventListener('turbolinks:load', () => {
      $(this.typeSelectTarget).on("change", function() {
        controller.toggle(true)
      })
    })
    this.element.addEventListener('submit', (e) => {
      if (this.isSecurityForm && this.lockedValue) e.preventDefault()
    })
  }

  toggle(animate) {
    const select = this.typeSelectTarget
    const selectedOption = select.options[select.selectedIndex]
    const isSecurityForm = selectedOption && selectedOption.dataset.securityForm === "true"
    this.isSecurityForm = isSecurityForm

    if (this.hasNomDeviceTarget) {
      if (animate) {
        if (isSecurityForm) {
          $(this.nomDeviceTarget).slideUp()
        } else {
          $(this.nomDeviceTarget).slideDown()
        }
      } else {
        this.nomDeviceTarget.style.display = isSecurityForm ? "none" : ""
      }
    }

    if (animate) {
      const isLocked = isSecurityForm && this.lockedValue
      if (this.hasSubmitButtonsTarget) {
        this.submitButtonsTarget.classList.toggle('d-none', isLocked)
      }
      if (this.hasLockedMessageTarget) {
        this.lockedMessageTarget.classList.toggle('d-none', !isLocked)
      }
    }

    if (this.hasSeveritySelectTarget) {
      const severitySelect = this.severitySelectTarget
      if (isSecurityForm) {
        const securityOption = Array.from(severitySelect.options).find(o => o.dataset.securityForm === "true")
        if (securityOption) {
          $(severitySelect).val(securityOption.value).trigger("change")
          if (this.hasSeverityHiddenTarget) {
            this.severityHiddenTarget.value = securityOption.value
          }
        }
        $(severitySelect).prop("disabled", true)
      } else {
        $(severitySelect).prop("disabled", false)
      }
    }
  }
}
